<template>
  <div>
    <!-- ============== Condition initial / not yet searching ============== -->
    <div v-if="!displayQuota">
      <div v-if="company.ship_schedule_quota > 0" class="searchinit">
        <div style="width: min-content">
          <img src="@/assets/image/icon/search-location.svg" alt="btn-search-loc">
        </div>
        <p class="desc">Select port of origin, port of destination and shipping line, then input vessel schedule, time interval and press search button</p>
      </div>
      <div v-else class="searchinit">
        <div style="width: min-content">
          <img src="@/assets/image/icon/icon-location-not-found.svg" alt="icon-location-not-found">
        </div>
        <p class="desc">You don’t have any vessel schedule search quota</p>
        <p class="desc">Kindly <span class="request" @click="openModalRequest">request</span> for more quota to our sales team</p>
      </div>
    </div>

    <!-- ============== Condition loading ============== -->
    <div v-else-if="isLoadingDataVesselSchedule" class="searchinit">
      <div style="width: min-content">
        <b-spinner small variant="secondary"></b-spinner>
      </div>
      <p class="loading1">Loading...</p>
      <p class="loading2">Please wait. It will take a few seconds.</p>
    </div>

    <!-- ============== Condition error ============== -->
    <!-- <div v-else-if="dataShipmentSchedule.result.error" class="searchinit">
      <p class="error">{{ dataShipmentSchedule.result.error.message }}</p>
    </div> -->

    <!-- ============== Condition no routes were found (array length = 0) ============== -->
    <SectionNotFound
      v-else-if="!dataFetchVesselSchedule && !dataFetchVesselSchedule.length && !isLoadingDataVesselSchedule"
      description="No schedules found."
    />
    
    <!-- ============== Condition Result ============== -->
    <div v-else class="row mx-0 mt-4">
      <FilterSection
        :dataVesselShipment="dataVesselShipment"
        @filterShippingLine="filterShippingLine"
      />
      <ResultSection
        :dataVesselShipment="dataVesselShipment"
        :dataVesselShipmentLength="dataVesselShipment.length"
      />
    </div>
  </div>
      <!-- ============== Condition didn't have any quota left ============== -->
</template>

<script>
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
// eslint-disable-next-line no-unused-vars
import moment from 'moment'
import { mapGetters } from 'vuex'
import FilterSection from './FilterSection.vue'
import ResultSection from './ResultSection.vue'
import SectionNotFound from './SectionNotFound.vue'
export default {
  name: 'ResultShipmentSchedule',
  props: {},
  data () {
    return {
      dataShipmentScheduleAvailable: false,
      displayQuota: false,
      dataVesselShipment: [],
      selectedFilterShippingLines: [],
      tempDataVesselShipment: []
    }
  },
  components: {
    FilterSection,
    ResultSection,
    SectionNotFound
  },
  computed: {
    ...mapGetters({
      dataFetchVesselSchedule: 'vesselSchedule/dataVesselSchedule',
      isLoadingDataVesselSchedule: 'vesselSchedule/isLoadingDataVesselSchedule',
      errorDataVesselSchedule: 'vesselSchedule/errorDataVesselSchedule',

      company: 'settingCompany/company'
    })
  },
  watch: {
    dataFetchVesselSchedule (val) {
      if (val) {
        this.dataVesselShipment = val
      }
    }
  },
  mounted () {
    this.fetchCompanyProfile()
  },
  methods: {
    filterShippingLine (params) {
      const tempDataVesselShipmentDeepCopy = JSON.parse(JSON.stringify(this.dataFetchVesselSchedule)) // deep copy
      this.dataVesselShipment = tempDataVesselShipmentDeepCopy
      let spliceIdx = []
      this.dataVesselShipment.forEach((el, idx) => {
        let temp = []
        el.dataScheduleShipment.forEach((el2) => {
          if (params.includes(el2.shippingLine)) temp.push(el2)
        })
        el.dataScheduleShipment = temp
        if (!temp.length) {
          spliceIdx.push(idx)
        }
      })
      this.dataVesselShipment = this.dataVesselShipment.filter(el => el.dataScheduleShipment.length)
    },
    fetchCompanyProfile () {
      this.$store.dispatch('settingCompany/FETCH_COMPANY').then(() => {
        if (this.company.ship_schedule_quota) {
          this.displayQuota = true
        }
      })
    },
    openModalRequest () {
      this.$eventHub.$emit('dialog-request-quota-schedule')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vesselSchedule/ResultVesselSchedule.vue